import type { FaireProductEntity } from "../../entity_types/product";

export const p_mhwh6u3akd: FaireProductEntity = {
  token: "p_mhwh6u3akd",
  type: "product",
  name: "Ultra Soft Plush Leopard Print Throw Blanket",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/c7d26d272cac10754a7a858f11d380b463187815b35886b1ac4e1ef1a815adeb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b71bf6037b08e1910d8d712794ae3737f29ff6f01add2ecf2d3e3377832a6e4.jpeg",
    "https://cdn.faire.com/fastly/785b9ec890eb34eb4265af9c4cc721c24fa94029a44ffad9b257ee49289025a4.jpeg",
    "https://cdn.faire.com/fastly/13f05bbbc429e1bf2b528cd1d4fc02236817a5bdcd79e7cab5a8194ccd23a12e.jpeg",
    "https://cdn.faire.com/fastly/f8a953c6e03dc918cb9236bf12b734402e368a0e01a1b065b030ba67c55eb217.jpeg",
    "https://cdn.faire.com/fastly/cc150ab69373b841b34ef3396c805d0ac1980020abcf1468eaef200ac4f34fde.jpeg",
    "https://cdn.faire.com/fastly/b098d7098275bc919552e954aaaf8ac0bfcb2fb16f0202095efc2adecf38ccaf.jpeg"
  ],
  priceDollars: 65,
  description: "Wrap yourself in cloud-like comfort with a hint of wild. The Marshmallow Leopard Blanket features an irresistibly soft, plush knit that feels like a warm hug—finished with a bold, tonal leopard print for just the right pop of personality.\nOffered in two rich colorways—Wild Espresso, a deep coffee-toned mix, and Wild Grey, a cool, modern neutral—this oversized blanket is perfect for lounging, gifting, or elevating your space with cozy, effortless style.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n•  54\" x 72\"\n• Ultra-soft marshmallow knit with a brushed, cozy finish\n• Statement leopard pattern in versatile, muted tones\n• Generously sized for full-body comfort\n• Machine washable and made to keep its softness",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:06.151Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
